import React, { useEffect, useState } from 'react';
import { Row, Col, Input, Card, Tooltip, DatePicker, Button, Tag, Progress } from 'antd';
import moment from 'moment';
import { AmazonOutlined, ArrowsAltOutlined, WarningOutlined } from '@ant-design/icons';
import { connect } from 'dva';
import GoBackOtherIcon from '../../GoBackOtherIcon';
import {
  DEFAULT_AWS_REGION,
  generateAWSResouceLink,
  generateGCPResourceLink,
  getBaseLink,
} from './Utils/ResourceLinks';
import AllServices from '../../../../../config/AllServices';
import { COLOR } from '@/utils/color';

const { Search } = Input;

function SingleResourceHeader(props) {
  const {
    specificResourceId,
    specificResourceName,
    selectedDate,
    handleHistoryChange,
    cloudAccName,
    resourceID,
    dispatch,
    singleRisk,
    organisation,
    region,
    service,
    cveInstanceDetails,
    loading,
    projectId,
  } = props;

  const handleCloudNames = cloudAccount => {
    if (!singleRisk.cloudAccount) {
      dispatch({
        type: 'singleRisk/changeCloudAccount',
        payload: {
          cloudAccount: cloudAccount,
        },
      });
    }
  };

  const removeAllSpaces = str => {
    return str.replace(/\s/g, '');
  };

  const generateResourceLink = (service, resourceId, resourceName, resourceRegion, cloudName) => {
    const region =
      resourceRegion && !Array.isArray(resourceRegion) ? resourceRegion : DEFAULT_AWS_REGION;

    const paramData = {
      service: service.toUpperCase(),
      resourceId,
      resourceName,
      region,
      projectId,
    };

    if (cloudName.toUpperCase() === 'AWS') {
      // *@ generate AWS resource link
      const resourceNavigationLink = generateAWSResouceLink(paramData);
      // *@ if the link is not valid, return the default link
      if (resourceNavigationLink) {
        return resourceNavigationLink;
      } else {
        const serviceNameWithSpaces = AllServices.getServiceName(service);
        let serviceName = '';
        // *@@ if service name available, then remove all spaces and convert to lowercase
        if (serviceNameWithSpaces) {
          serviceName = removeAllSpaces(serviceNameWithSpaces).toLowerCase();
        } else {
          const [serviceType, serviceCategory] = service.split(':');
          serviceName = serviceType.toLowerCase();
        }
        return getBaseLink(region, serviceName);
      }
    } else if (cloudName.toUpperCase() === 'GCP') {
      const resourceNavigationLink = generateGCPResourceLink(paramData);
      if (resourceNavigationLink) {
        return resourceNavigationLink;
      }
      return `https://cloud.google.com/`;
    } else if (cloudName.toUpperCase() === 'AZURE') {
      // TODO: add Azure link generator
      return `https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?redirect_uri=https%[…]ient-SKU=ID_NET472&x-client-ver=6.16.0.0&sso_reload=true`;
    }
  };

  const scanSingleResource = () => {
    let obj = {
      resource: specificResourceId,
      cloudAccountId: cloudAccName[0].id,
      orgId: organisation.id,
      signature: [], //string
      service,
      region: [region],
    };
    dispatch({
      type: 'singleRisk/scanSingleResource',
      payload: {
        resouceInfo: obj,
      },
    });
    setTimeout(
      () =>
        dispatch({
          type: 'singleRisk/scanSingleResource',
          payload: {
            resouceInfo: obj,
          },
        }),
      3000
    );
  };

  const testID = resourceID;

  return (
    <Card style={{ margin: '-30px -20px -20px -40px' }} bordered={false}>
      <div className="sig-card" style={{ marginTop: 10 }}>
        <Row style={{ alignItems: 'center' }}>
          <Col span={1}>
            <span style={{ marginLeft: 8 }}>
              <GoBackOtherIcon />
            </span>
          </Col>

          <Col span={11}>
            <p style={{ color: '#8C8C8C', margin: 0 }}>Resource Profile</p>
          </Col>

          <Col span={12}>
            <div
              style={{
                display: 'flex',
                float: 'right',
                marginRight: 10,
                alignItems: 'center',
                gap: '1rem',
              }}
            >
              {/* <Button
                style={{
                  height: '40px',
                  background: 'rgba(245, 245, 245, 0.3)',
                  color: 'black',
                  fontSize: '14px',
                  borderRadius: '8px',
                  boxShadow: '0px 0px 0px',
                  border: '1px solid #D9D9D9',
                  boxSizing: 'border-box',
                }}
                type="primary"
                loading={loading}
                disabled={loading}
                onClick={scanSingleResource}
              >
                {loading ? 'Scanning resource' : 'Scan Resource'}
              </Button> */}
              <Tooltip placement="bottom" title="Coming Soon">
                <Button
                  style={{
                    height: '40px',
                    // background: 'rgba(245, 245, 245, 0.3)',
                    // color: 'black',
                    fontSize: '14px',
                    borderRadius: '8px',
                    boxShadow: '0px 0px 0px',
                    border: '1px solid #D9D9D9',
                    boxSizing: 'border-box',
                  }}
                  // type="primary"
                  disabled={true}
                >
                  Scan Resource
                </Button>
              </Tooltip>
              <a
                style={{
                  height: '40px',
                  background: 'rgba(245, 245, 245, 0.3)',
                  border: '1px solid #D9D9D9',
                  boxSizing: 'border-box',
                  borderRadius: '8px',
                  width: 'max-content',
                  padding: '10px',
                  color: 'black',
                }}
                href={
                  cloudAccName &&
                  cloudAccName.length &&
                  generateResourceLink(
                    service,
                    specificResourceId,
                    specificResourceName,
                    region,
                    cloudAccName[0].provider
                  )
                }
                target="_blank"
              >
                <span
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                    justifyContent: 'center',
                    fontSize: '14px',
                  }}
                >
                  <img
                    src={
                      cloudAccName &&
                      cloudAccName.length &&
                      cloudAccName[0].provider.toLowerCase() === 'aws'
                        ? '/awslist.png'
                        : cloudAccName &&
                          cloudAccName.length &&
                          cloudAccName[0].provider.toLowerCase() === 'azure'
                        ? '/azure@2x.png'
                        : '/gcplogo.png'
                    }
                    alt="cloud provider logo here"
                    style={{ width: '20px', marginRight: '10px' }}
                  />
                  Open Resource in {cloudAccName && cloudAccName.length && cloudAccName[0].provider}
                  <svg
                    style={{ marginLeft: '25px' }}
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.7583 0.0507812H9.48709C9.30628 0.0507812 9.15984 0.197222 9.15984 0.378027C9.15984 0.558659 9.30628 0.705099 9.48709 0.705099H12.7583C12.9041 0.705617 13.0478 0.73912 13.1787 0.80319L6.63889 7.34341C6.57569 7.40437 6.53977 7.48813 6.53908 7.57603C6.53821 7.66375 6.57275 7.74802 6.63475 7.81002C6.69692 7.87219 6.78119 7.90673 6.86892 7.90587C6.95665 7.90518 7.0404 7.86908 7.10136 7.80605L13.642 1.26627C13.7059 1.39717 13.7396 1.54085 13.7401 1.6866V4.95786C13.7401 5.13849 13.8866 5.28493 14.0672 5.28493C14.2478 5.28493 14.3943 5.13849 14.3943 4.95786V1.6866C14.3937 1.25297 14.2214 0.837128 13.9147 0.53063C13.608 0.223933 13.1923 0.0514089 12.7587 0.0508784L12.7583 0.0507812Z"
                      fill="#565656"
                    />
                    <path
                      d="M14.0664 6.5931C13.8858 6.5931 13.7394 6.73954 13.7394 6.92017V12.8088C13.7394 13.069 13.6359 13.3187 13.4518 13.5026C13.2679 13.6867 13.0182 13.7901 12.758 13.7901H6.5427V9.5375C6.54218 9.10387 6.36966 8.68803 6.06295 8.38153C5.75642 8.07483 5.34058 7.90231 4.90698 7.90178H0.654332V1.68649C0.654332 1.42624 0.757772 1.17654 0.941688 0.992456C1.12578 0.80854 1.37549 0.7051 1.63572 0.7051H7.52431C7.70494 0.7051 7.85138 0.558659 7.85138 0.378027C7.85138 0.197222 7.70494 0.0507812 7.52431 0.0507812H1.63572C1.20209 0.0512993 0.786251 0.223818 0.479752 0.530534C0.173055 0.837058 0.000530504 1.2529 0 1.6865V12.809C0.000518081 13.2426 0.173037 13.6582 0.479752 13.9649C0.786277 14.2716 1.20212 14.444 1.63572 14.4445H12.7582C13.1918 14.444 13.6075 14.2716 13.9141 13.9649C14.2208 13.6582 14.3932 13.2425 14.3937 12.809V6.92036C14.3937 6.83367 14.3593 6.75043 14.298 6.68913C14.2366 6.62765 14.1535 6.59328 14.0666 6.59328L14.0664 6.5931ZM0.653992 12.8084V8.55574H4.90664C5.16688 8.55574 5.41659 8.65901 5.60067 8.8431C5.78459 9.02719 5.88803 9.27672 5.88803 9.53713V13.7898H1.63538C1.37514 13.7898 1.12543 13.6863 0.941348 13.5023C0.757431 13.3183 0.653992 13.0686 0.653992 12.8084V12.8084Z"
                      fill="#565656"
                    />
                  </svg>
                  {handleCloudNames(
                    cloudAccName && cloudAccName.length && cloudAccName[0].provider.toUpperCase()
                  )}
                </span>
              </a>
            </div>
          </Col>
        </Row>

        <Row type="flex" style={{ marginBottom: 5 }}>
          <Col offset={1}>
            <Tooltip placement="bottom" title={specificResourceId}>
              <div style={{ fontSize: '30px', fontWeight: 500, lineheight: '36px' }}>
                {specificResourceName.length > 50
                  ? specificResourceName.substring(0, 50).concat('..')
                  : specificResourceName}
              </div>
            </Tooltip>
          </Col>
          {cveInstanceDetails.isFailed && (
            <Col
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Tooltip placement="bottom" title={cveInstanceDetails.failureReason}>
                <WarningOutlined
                  style={{
                    color: COLOR.WARNING,
                    marginLeft: 10,
                    fontSize: 18,
                  }}
                />
              </Tooltip>
            </Col>
          )}
        </Row>
        <Row type="flex" style={{ marginBottom: 5 }}>
          <Col offset={1}>
            <p
              style={{
                fontSize: '14px',
                fontWeight: 500,
                lineheight: '20px',
                color: 'rgba(0, 0, 0, 0.5)',
              }}
            >
              {testID}
            </p>
          </Col>
        </Row>
      </div>
    </Card>
  );
}

export default connect(({ singleRisk }) => ({
  singleRisk,
}))(SingleResourceHeader);
